import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddRewardModal from './AddRewardModal';
import RewardList from '../../RewardList';

class Reward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModalAtFirst,
    };
  }

  render() {
    const { rewards, removeReward, removeRewardItem } = this.props;
    const isDisabledNext = rewards.length === 0;
    return (
      <div className="top20">
        <AddRewardModal
          addReward={this.props.addReward}
          rewards={this.props.rewards}
          show={this.props.isOpened && this.state.showModal}
          hideModal={this._hideAddRewardModal}
          loyaltySubscription={this.props.loyaltySubscription}
        />
        <div className="row bottom20 top20">
          <div className="col-md-12">Customer can exchange</div>
        </div>
        <RewardList
          rewards={rewards}
          removeReward={removeReward}
          removeRewardItem={removeRewardItem}
        />
        <div className="row bottom20">
          <div className="col-md-12">
            <button
              className="btn btn-primary form-control"
              onClick={this._onClickAddReward}
            >
              Add Reward
            </button>
          </div>
        </div>
        <button
          style={{ color: `${isDisabledNext ? '' : '#3e8acc'}` }}
          className="btn btn-default pull-right"
          onClick={this._onClickNext}
          disabled={isDisabledNext}
        >
          Next
        </button>
      </div>
    );
  }

  _onClickNext = e => {
    e.stopPropagation();
    this.props.onFinish();
  };

  _onClickAddReward = () => {
    this.setState({ showModal: true });
  };

  _hideAddRewardModal = () => {
    this.setState({ showModal: false });
  };
}

Reward.propTypes = {
  rewards: PropTypes.array.isRequired,
  addReward: PropTypes.func.isRequired,
  removeReward: PropTypes.func.isRequired,
  removeRewardItem: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
};

export default Reward;
